import {PersonnelService} from "@/common/api.service";
import {FETCH_COUNTRY_LIST,} from "./actions";
import {FETCH_COUNTRY_LIST_END,} from "./mutations";

const getDefaultState = () => {
    return {
        job: {},
        countryList: [],
        fatalFetchError: {
            state: false,
            value: "",
        },
    }
};

const state = getDefaultState();

const getters = {
    // job(state)
    // {
    //     return state.job;
    // },
    countryList: (state) => (isLive = false) => {
        let countryList = [];
        if (isLive == true) {
            countryList = state.countryList.filter(country => country.isLive == true && country.countryId != 0);
        } else {
            countryList = state.countryList;
        }

        // function compare(a, b) {
        //     // Use toUpperCase() to ignore character casing
        //     const nameA = a.name.toUpperCase();
        //     const nameB = b.name.toUpperCase();
        //
        //     let comparison = 0;
        //     if (nameA > nameB) {
        //         comparison = 1;
        //     } else if (nameA < nameB) {
        //         comparison = -1;
        //     }
        //     return comparison;
        // }

        // countryList.sort(compare);

        return countryList;
    },

    getCountryNameById: (state) => (countryId) => {
        const country = state.countryList.find(country => country.countryId == countryId);
        if (country) {
            // console.log(country.name);
            return country.name;
        }

    },
};

const actions = {
    [FETCH_COUNTRY_LIST]({commit}) {
        return PersonnelService.getCountryList()
            .then(({data}) => {
                commit(FETCH_COUNTRY_LIST_END, data);
            })
            .catch(error => {
                throw new Error(error);
            });
    },
    // [FETCH_JOB]({commit}, jobId)
    // {
    //     return PersonnelService.getJob(jobId)
    //         .then(({data}) => {
    //             commit(SET_JOB, data);
    //         })
    //         .catch(error => {
    //             throw new Error(error);
    //         });
    // },
    // [CANCEL_MANAGE_JOB_EDIT_STATE]({commit, dispatch}, params)
    // {
    //     dispatch(FETCH_JOB_LIST, params.personId);
    //     commit(TOGGLE_MANAGE_JOB_EDIT_STATE, params.field);
    // },
    // [SAVE_MANAGE_JOB]({commit, dispatch}, params)
    // {
    //     return PersonnelService.updateJobDetails(params)
    //         .then(({data}) => {
    //             commit(TOGGLE_MANAGE_JOB_EDIT_STATE, params.field);
    //             dispatch(FETCH_JOB, params.job.jobId);
    //             return data;
    //         });
    // },
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
    // [TOGGLE_MANAGE_JOB_EDIT_STATE](state, field)
    // {
    //     state.editStateJob[field] = !state.editStateJob[field];
    // },
    // [UPDATE_MANAGE_JOB_FIELD](state, data)
    // {
    //     state.job[data.field] = data.value;
    // },
    [FETCH_COUNTRY_LIST_END](state, data) {
        state.countryList = data;
    },
    // [SET_JOB](state, data)
    // {
    //     state.job = data;
    // },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
